import React from 'react'
import ValentineSiteTakeoverBackground from 'components/Common/SiteTakeover/ValentineSiteTakeoverBackground'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import moment from 'moment'

const ValentineTakeover: App.SiteTakeover = {
  id: 'valentine',
  startDate: moment('2025-02-12T08:00:00+1100'),
  endDate: moment('2025-02-15T02:59:00+1100'),
  brands: new Set(['luxuryescapes']),
  regions: new Set(['SG', 'HK', 'AE', 'ZA', 'IN']),
  imageId: 'gidua9dchhephstwu3jp',
  primaryColour: '#F84916',
  palette: 'default',
  offerTypes: new Set(['hotel']),
  verticals: new Set(['home', 'hotel']),
  heroCarousel: {
    title: 'Happy Valentine\'s Day',
    subtitle: <>Use code <b>LOVEISINTHEAIR</b> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025</>,
    verticals: ['home'],
  },
  backgroundElement: ValentineSiteTakeoverBackground,
  offerPage: {
    bannerContent: <>Use code <b>LOVEISINTHEAIR</b> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025</>,
  },
  landingPage: {
    banner: {
      description: <>Use code <b>LOVEISINTHEAIR</b> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025</>,
    },
  },
  searchPage: {
    bannerContent: <VerticalSpacer gap={2}>
      <Heading variant="heading2">Happy Valentine's Day</Heading>
      <BodyText variant="large">Use code <b>LOVEISINTHEAIR</b> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025</BodyText>
    </VerticalSpacer>,
  },

}

export default ValentineTakeover
